import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/auto_ventas/informes';
import Informes from './Informes';


const ms2p = (state) => {
  return {
    ...state.auto_ventas_informes,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Informes);
